import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { InterviewObservation } from './interview-observation';
export { InterviewObservation };
import { interviewObservationSchema } from '@schemas/business-objects/interview-observation';
import { InterviewFormGroup } from './interview-form-group';

export class InterviewObservationFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    enthusiasmScore: SchemaFormControl;
    azerbaijaniLevel: SchemaFormControl;
    englishLevel: SchemaFormControl;
    russianLevel: SchemaFormControl;
    persianLevel: SchemaFormControl;
    frenchLevel: SchemaFormControl;
    italianLevel: SchemaFormControl;
    spanishLevel: SchemaFormControl;
    germanLevel: SchemaFormControl;
    arabicLevel: SchemaFormControl;
    otherLanguage: SchemaFormControl;
    shiftPreference: SchemaFormControl;
    trainingAvailability: SchemaFormControl;
    lateShift: SchemaFormControl;
    specialRequest: SchemaFormControl;
    needAdditionalCheck: SchemaFormControl;
    totalScores: SchemaFormControl;
    interviewId: SchemaFormControl;
    interview: InterviewFormGroup;
  };

  declare value: Partial<InterviewObservation>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(interviewObservationSchema, InterviewObservation, data, options);
  }

  get object(): InterviewObservation {
    return new InterviewObservation(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'interview':
        return new InterviewFormGroup();
      default:
        return undefined;
    }
  }
}

export class InterviewObservationFormArray extends PersistedFormArray {
  readonly entityName = 'InterviewObservation' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(interviewObservationSchema, InterviewObservation, options);
  }

  protected override createItemGroup() {
    return new InterviewObservationFormGroup();
  }

  get array(): InterviewObservation[] {
    return this.controls.map(
      (group: InterviewObservationFormGroup) => group.object,
    );
  }
}

export class InterviewObservationPersistedArray extends PersistedArray<InterviewObservation> {
  readonly entityName = 'InterviewObservation' as const;

  constructor(options?: PersistedArrayOptions) {
    super(InterviewObservation, options);
  }
}
